import { render, staticRenderFns } from "./ReportQuizzesAndQuestions.vue?vue&type=template&id=52a799a0&scoped=true&"
import script from "./ReportQuizzesAndQuestions.vue?vue&type=script&lang=js&"
export * from "./ReportQuizzesAndQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ReportQuizzesAndQuestions.vue?vue&type=style&index=0&id=52a799a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a799a0",
  null
  
)

export default component.exports